import React, { CSSProperties } from 'react';
import cn from 'classnames';

import FsMinusInCircleIcon from 'ui-elements/icons/FsMinusInCircle';
import FsPlusInCircleIcon from 'ui-elements/icons/FsPlusInCircle';
import { ContainerBox } from './FsProsConsInfoBox.style-elements';
import { useContainerStyles, useStyles } from './FsProsConsInfoBox.style';

interface FsProsConsInfoBoxProps {
  type?: 'pros' | 'cons';
  style?: CSSProperties;
}

const FsProsConsInfoBox: React.FC<FsProsConsInfoBoxProps> = ({
  children,
  type = 'pros',
  style,
}) => {
  const isCons = type === 'cons';
  const containerClasses = { [useContainerStyles().root]: isCons };
  const { iconClass } = useStyles();

  return (
    <ContainerBox className={cn(containerClasses)} style={style}>
      {isCons ? (
        <FsMinusInCircleIcon className={iconClass} />
      ) : (
        <FsPlusInCircleIcon className={iconClass} />
      )}
      {children}
    </ContainerBox>
  );
};

export default FsProsConsInfoBox;
